<template>
  <div>
    <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
          >
            <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Terms and Conditions') }}</h1>
            <v-card
                class="mx-auto product-card"
                outlined
            >

              <v-card-text class="text--primary">
                <TermsContentNeotag v-if="brand === 'neotag'"/>
                <TermsContent v-else/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import TermsContent from "./TermsContent";
import TermsContentNeotag from "./TermsContentNeotag"
import Footer from "./Footer"
import {i18n} from "../i18n";
import {mapState} from "vuex";

export default {
  name: "Terms",
  metaInfo() {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Terms and Conditions'),
      htmlAttrs: {
        lang: i18n.locale
      }
    }
  },
  components: {
    TermsContent,
    TermsContentNeotag,
    Footer
  },
  computed: {
    ...mapState({
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/hp-banner-1.jpg')
      }
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
}
</script>

<style scoped>

</style>
